module.exports = __webpack_public_path__ + "img/OT497.f3334a8.webp";